import { useMutation } from 'react-query';
import { queryClient } from '../../../../../../../../config/queryClient';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../../../../../CommonUtils/urlWithParams';
import { SocialSecurityStrategy, SocialSecurityWhatIf } from './types';
import { ProbabilityModelDTO } from './useSocialSecurityProbabilityQuery';
import { queryKeys } from './queryKeys';

export interface Params {
  clientId: number;
  fpId: string;
  strategy: SocialSecurityStrategy;
  body: SocialSecurityWhatIf[];
  signal?: AbortSignal;
}

export const fetchSocialSecurityProbabilityWithWhatIfs = ({
  clientId,
  fpId,
  strategy,
  body,
  signal,
}: Params): Promise<ProbabilityModelDTO> => {
  return authFetch(
    urlWithParams(
      '/Consumer/OptimizeSocialSecurity/GetSocialSecurityProbabilityWithWhatIfs',
      { clientId, fpId, strategy },
    ),
    {
      method: 'POST',
      ...httpBodyOptions(body, true),
      signal,
    },
  );
};

interface HookParams {
  clientId: number;
  fpId: string;
  strategy: SocialSecurityStrategy;
}

export const useSocialSecurityProbabilityWithWhatIfsMutation = ({
  clientId,
  fpId,
  strategy,
}: HookParams) => {
  return useMutation(fetchSocialSecurityProbabilityWithWhatIfs, {
    onSuccess() {
      queryClient.invalidateQueries(
        queryKeys.socialSecurityProbability(clientId, fpId, strategy),
      );
    },
  });
};
